import { useQuery, queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";

export const getOrganizationQuery = () => {
  return queryOptions({
    queryKey: ["organization", "get"],
    queryFn: async () => {
      return handleClientMethod(getClient().GET("/organization"));
    },
  });
};

export const useGetOrganization = () => {
  return useQuery(getOrganizationQuery());
};
